export function clickOutside(node, params) {
    const handleClick = (event) => {
        const clickedElement = event.target;
        if (!node.contains(clickedElement)) {
            params.callback();
        }
    };
    window.addEventListener('click', handleClick);
    return {
        destroy() {
            window.removeEventListener('click', handleClick);
        }
    };
}
